/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Paid_Free_TInputs */



/**
* | output |
* | --- |
* | "Nothing to collect" |
*
* @param {Tournament_Wiz_Tip_Paid_Free_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_paid_free_t = /** @type {((inputs?: Tournament_Wiz_Tip_Paid_Free_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Paid_Free_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien à encaisser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nada que cobrar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nada a receber")
	if (locale === "it") return /** @type {LocalizedString} */ ("Niente da incassare")
	return /** @type {LocalizedString} */ ("Nothing to collect")
});